import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_MEMBER } from 'src/hooks/accounts/get-current-member-account.hook';

import { GET_GANTTS } from './get-gantts.hook';

const DELETE_GANTT = gql`
  mutation deleteGanttById($ganttId: String!) {
    deleteGanttById(ganttId: $ganttId)
  }
`;

export const useDeleteGanttById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteGantt] = useMutation(DELETE_GANTT, {
    refetchQueries: [GET_GANTTS, GET_CURRENT_MEMBER],
    onCompleted: onSuccess,
  });

  return deleteGantt;
};
